
import React from 'react';
import { INSTAGRAM_POSTS } from '../constants';
import { Instagram } from 'lucide-react';
import { SOCIALS } from '../constants';

const SocialProof: React.FC = () => {
  return (
    <section className="py-32 bg-brand-offwhite">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <span className="text-[10px] uppercase tracking-[0.6em] text-brand-gold mb-4 block font-bold">
            Communauté R & C
          </span>
          <h2 className="font-serif text-4xl md:text-5xl">Moments de Sérénité</h2>
          <p className="mt-6 text-gray-400 font-light italic text-sm">Partagez votre rituel avec le hashtag #R&Cessentials</p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {INSTAGRAM_POSTS.map((post, idx) => (
            <a 
              key={idx} 
              href={post.url} 
              target="_blank" 
              rel="noreferrer" 
              className="relative group overflow-hidden rounded-2xl aspect-square bg-brand-cream border border-brand-gold/10"
            >
              <img src={post.image} alt="Soin R&C" className="w-full h-full object-cover luxury-transition group-hover:scale-110" />
              <div className="absolute inset-0 bg-brand-gold/20 opacity-0 group-hover:opacity-100 luxury-transition flex items-center justify-center">
                <Instagram className="text-white" size={32} />
              </div>
            </a>
          ))}
        </div>

        <div className="mt-20 text-center">
          <a href="https://www.instagram.com/randcessentials_/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-4 text-[10px] uppercase tracking-[0.4em] font-bold text-brand-black hover:text-brand-gold transition-all border-b border-brand-black/10 pb-4">
            Rejoindre l'Art de Vivre
            <Instagram size={14} />
          </a>
        </div>  

        <div className="mt-20 text-center">
          <a href={SOCIALS.tiktok.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-4 text-[10px] uppercase tracking-[0.4em] font-bold text-brand-black hover:text-brand-gold transition-all border-b border-brand-black/10 pb-4">
            Suivez-nous sur TikTok
            <svg 
              width="14" 
              height="14" 
              viewBox="0 0 24 24" 
              fill="currentColor" 
              className="group-hover:rotate-12 transition-transform"
            >
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .8.11V9.4a6.33 6.33 0 0 0-1-.08A6.34 6.34 0 0 0 3 15.66a6.34 6.34 0 0 0 10.86 4.43 6.34 6.34 0 0 0 3.14-5.42V8.23a8.16 8.16 0 0 0 4.59 1.48V6.26a4.86 4.86 0 0 1-2-.45z"/>
            </svg>
          </a>
        </div>  

        <div className="mt-20 text-center">
          <a 
            href={SOCIALS.snapchat.url} 
            target="_blank" 
            rel="noreferrer" 
            className="inline-flex items-center gap-4 text-[10px] uppercase tracking-[0.4em] font-bold text-brand-black hover:text-brand-gold transition-all border-b border-brand-black/10 pb-4"
          >
            Ajoutez-nous sur Snapchat 
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="currentColor" 
              className="group-hover:rotate-12 transition-transform"
            >
              <path d="M12 2.75c-4.14 0-7.5 3.12-7.5 6.96 0 1.09.28 2.11.77 3.01-.54.34-1.21.84-1.21 1.78 0 .61.35 1.05.9 1.34-.14.28-.21.58-.21.89 0 1.15 1.01 2.08 2.25 2.08.21 0 .42-.03.61-.09.64.67 1.63 1.11 2.74 1.22.45.69 1.06 1.3 1.65 1.3s1.2-.61 1.65-1.3c1.11-.11 2.1-.55 2.74-1.22.19.06.4.09.61.09 1.24 0 2.25-.93 2.25-2.08 0-.31-.07-.61-.21-.89.55-.29.9-.73.9-1.34 0-.94-.67-1.44-1.21-1.78.49-.9.77-1.92.77-3.01 0-3.84-3.36-6.96-7.5-6.96z" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
